import React ,{useState} from 'react';
import { Helmet } from 'react-helmet-async'
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import {  formatDate } from 'utils/utils.js';
import { Calendararea } from './style';
export default function MonthRangePicker({startDate, endDate, setStartDate, setEndDate,disabledDate}) {
 
  const [displayedMonth, setDisplayedMonth] = useState(new Date());  

  let handleDayClick = (day) => {
    let prevRange = {};
    if(startDate)
    {
      prevRange['from'] = new Date(startDate);
    }
    if(endDate)
    {
      prevRange['to'] = new Date (endDate);
    }
    const newRange = DateUtils.addDayToRange(day, prevRange);
    if(newRange['from'] )
    {
      setStartDate(formatDate(newRange['from']))
    }

    if(newRange['to'] )
    {
      setEndDate(formatDate(newRange['to']))
    }

    setDisplayedMonth(day);
  }


  let modifiers = {}
  let selectedRange = {};
  if(startDate)
  {
    modifiers['start'] = new Date(startDate);
    selectedRange['from'] = new Date(startDate);
  }
  if(endDate)
  {
    modifiers['end'] = new Date(endDate);
    selectedRange['to'] = new Date(endDate);
  }

  if(!startDate || !endDate)
  {

    modifiers['hiderange'] =  (!startDate) ? new Date(endDate) : new Date(startDate);
  }
  else if(startDate && endDate && formatDate(startDate) === formatDate(endDate))
  {
    modifiers['hiderange'] =  new Date(endDate);
  }


  return(
    <>
      <Calendararea id="calendar-month-range-picker-section">
        <DayPicker
            month={displayedMonth}
            className="calendar-month-range-picker"
            numberOfMonths={1}
            onDayClick={handleDayClick}
            modifiers={modifiers}
            selectedDays={[startDate,selectedRange]}
            disabledDays={{before: new Date()}}
         />
         </Calendararea>
        <Helmet>
          <style>{`
        `}</style>
        </Helmet>
    </>
  );
}
